var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { CaseApplyManageService } from "~/services/business-service/case-apply-manage.service";
import { Emit, Prop } from "vue-property-decorator";
import { SortService } from "~/utils/sort.service";
import { PageService } from "~/utils/page.service";
import DataBox from "~/components/common/data-box.vue";
var VisitManageFinish = /** @class */ (function (_super) {
    __extends(VisitManageFinish, _super);
    function VisitManageFinish() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false,
        };
        _this.assistDataSet = [];
        _this.manualModel = {
            batchNum: "",
            closeDate: "",
            companyCode: "",
            type: "",
        };
        _this.visitDataSet = [];
        _this.searchModel = {
            assistStatus: "",
        };
        return _this;
    }
    VisitManageFinish.prototype.refreshList = function () { };
    VisitManageFinish.prototype.close = function () { };
    VisitManageFinish.prototype.refreshData = function () {
        var _this = this;
        var searchModel = Object.assign(this.searchModel, this.visitModel);
        searchModel.assistStatus = "ASSIST_COMPLETED"; //已完成
        // searchModel.applyDateStart = this.visitModel.applyDate[0]
        // searchModel.applyDateEnd = this.visitModel.applyDate[1]
        // searchModel.applyDate =''
        this.caseApplyManageService.searchAssistCase(searchModel, this.pageService, this.sortService, this.loading).subscribe(function (data) {
            _this.visitDataSet = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    __decorate([
        Dependencies(PageService)
    ], VisitManageFinish.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], VisitManageFinish.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseApplyManageService)
    ], VisitManageFinish.prototype, "caseApplyManageService", void 0);
    __decorate([
        Emit("refreshList")
    ], VisitManageFinish.prototype, "refreshList", null);
    __decorate([
        Emit("close")
    ], VisitManageFinish.prototype, "close", null);
    __decorate([
        Prop()
    ], VisitManageFinish.prototype, "selectionList", void 0);
    __decorate([
        Prop()
    ], VisitManageFinish.prototype, "visitModel", void 0);
    VisitManageFinish = __decorate([
        Component({
            components: {
                DataBox: DataBox,
            },
        })
    ], VisitManageFinish);
    return VisitManageFinish;
}(Vue));
export default VisitManageFinish;
